import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Checkbox } from '@fiverr-private/forms';
import styles from './DrawerMenuItem.module.scss';

interface ListMenuItemProps {
    children: React.ReactNode;
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const DrawerMenuItem = ({ children, checked, onChange }: ListMenuItemProps) => (
    <Container
        as="label"
        display="flex"
        paddingY="3"
        alignItems="center"
        borderRadius="lg"
        cursor="pointer"
        className={styles.checkboxWrapper}
    >
        <Checkbox checked={checked} onChange={onChange}>
            <Container order="-1" flex="1" display="flex" alignItems="center" minWidth="0px" paddingRight="3">
                {children}
            </Container>
        </Checkbox>
    </Container>
);
